'use strict';
import { fetchAllSampleSets } from '@/discovery-panel/api';
import { DiscoveryPanelMap } from '@/enums/Enums';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './ProjectItem.scss';

/** Kits projects show their full title instead of the internal DCENT-PROJ code. */
export const getProjectItemLabels = ({ projectCode, projectTitle, customerProjectTitle }) => {
	if (/^DCENT-PROJ-/i.test(projectCode || '')) {
		return { primary: customerProjectTitle || projectTitle || projectCode, secondary: 'Kits Project' };
	}
	return {
		primary: projectCode,
		secondary: customerProjectTitle || (projectTitle ? projectTitle.replace(projectCode, '') : ''),
	};
};

export const ProjectItem = ({ isDiscoveryPanel = false, onSelect, ...props }) => {
	const [project, setProject] = useState(props.project);
	const { projectCode, projectId, projectTitle, customerProjectTitle } = project;
	const [discoverySampleSets, setDiscoverySampleSets] = useState(null);
	const { primary, secondary } = getProjectItemLabels({ projectCode, projectTitle, customerProjectTitle });

	useEffect(() => {
		setProject(props.project);
	}, [props.project]);

	useEffect(() => {
		const fetch = async () => {
			const sampleSets = await fetchAllSampleSets(projectId);
			setDiscoverySampleSets(sampleSets);
		};
		if (!isDiscoveryPanel) return;
		fetch();
	}, [isDiscoveryPanel]);

	if (!isDiscoveryPanel) {
		const id = project.publishDate ? projectCode : project.projectId;
		
		if (onSelect) {
			return (
				<div className="itemContainer selectable" onClick={() => onSelect(project)}>
					<span className="code" style={{ cursor: 'pointer' }}>
						{primary}
					</span>
					<label className="desc" size="small">{secondary}</label>
				</div>
			);
		}
		
		return (
			<div className="itemContainer">
				<Link to={`/home/project/${id}/home`} className="code" alt2={"true"} size="normal" color="quinary">
					{primary}
				</Link>
				<label className="desc" size="small">{secondary}</label>
			</div>
		);
	}
	//const path = isDiscoveryPanel ? "/discovery-panels/" + projectId : 


	if (onSelect) {
		return (
			<div className="itemContainer selectable" onClick={() => onSelect(project)}>
				<span className="code" style={{ cursor: 'pointer' }}>
					{primary}
				</span>
				<label className="desc" size="small">{secondary}</label>
			</div>
		);
	}
	//const path = isDiscoveryPanel ? "/discovery-panels/" + projectId : 


	return (
		discoverySampleSets && Object.keys(discoverySampleSets).map((productType) => {

			return discoverySampleSets[productType].map((sampleSetId) =>
				<div className="itemContainer" key={sampleSetId}>
					<Link to={`/discovery-panels/${projectId}/${productType}/${sampleSetId}`} className="code" alt2={"true"} size="normal" color="quinary">
						{primary}
						{isDiscoveryPanel && ` DiscoveryPanel ${DiscoveryPanelMap.ui[productType]}`}
					</Link>
					<label className="desc" size="small">{secondary}</label>
				</div>
			);
		})

	);
};

export default ProjectItem;
